import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from "@angular/router";
import { Observable } from "rxjs";
import { CircularInjectionHelper } from "../services/circularInjectionHelper";
import { UserHelperService } from "../services/userHelper.service";
import { MatBottomSheet } from "@angular/material";
import { RouterHelperService } from "../services/routerHelper.service";
import { PopStateDirection } from "../shared/contentTypes";
import { Location } from "@angular/common";
import { LoginDialogComponent } from "../modalDialogs/logindialog/logindialog.component";
import { BottomSheetHelperService } from "../services/bottomSheetHelper.service";
import { WebShopService } from "../services/webShop.service";

@Injectable({
  providedIn: "root"
})
export class FixedBasketGuard implements CanActivateChild {
  constructor(private _userHelperService: UserHelperService
    , private _routerHelperService: RouterHelperService
    , private _router: Router
    , private _webshopService: WebShopService) {

  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const me = this;
    const fixedBasketRoutes = [
      "webshop",
      "orderresult",
      "registration",
      "registrationdata",
      "loginactivation",
      "forgetpassword",
      "userprofile",
      "userprofiledetail/:tabIndex",
      "changepassword",
      "fixedBasketError",
      "load",
      "useraddress/:addresType",
      "useraddress/:addresType/:addressId",
      "billinginfo",
      "bonusaction",
      "bonusactiondetail/:id",
      "userlike",
      "feedback",
      "webvoucher",
      "webvoucherdetail",
    ];
    if (me._webshopService.allowBasketModification) {
      return true;
    } else {
      // when use back button or forward in browser pass userprofile page
      if (fixedBasketRoutes.includes(next.routeConfig.path)) {
        return true;
      } else {
        me._router.navigate(["webshop"]);
      }
    }
  }
}
